import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-number-card',
  templateUrl: './number-card.component.html',
  styleUrls: ['./number-card.component.css'],
})
export class NumberCardComponent {
  @Input()
  number: string = '0';
  @Input()
  name: string = '';
}
